<template>
	<div class="page">
		<!-- your page -->
		<Head></Head>
		<div class="container">
			<div class="fixation">
				<div class="filtrate">
					<div class="block" v-for="(item,index) in filtrate" :key="index" :style="height">
						<div class="blockTitle">
							{{item.name}}
						</div>
						<div class="blockBox">
							<div class="blockItem" v-for="(tab,tabIndex) in item['tab']" :key="tabIndex" :data-id="tab.id" @click="getSearch" :data-index="item.id" :id="tab.select">
								{{tab.name}}
							</div>
						</div>
						<div class="blockMore">
							<!-- <div class="moreBtn">
								更多
								<i class="el-icon-arrow-down"></i>
							</div> -->
						</div>
					</div>
					<div class="clearFiltrate"><div class="clearIn" @click="clearFiltrate">清除筛选</div></div>
				</div>
				<div class="order">
					<div class="default" @click="getDefault" :id="select1">综合</div>
					<div class="sales" @click="getSales" :id="select2">销量<i class="el-icon-sort-up" v-if="select2up==true"></i><i class="el-icon-sort-down" v-if="select2up==false"></i></div>
					<div class="price" @click="getPrice" :id="select3">价格<i class="el-icon-sort-up" v-if="select3up==true"></i><i class="el-icon-sort-down" v-if="select3up==false"></i></div>
				</div>
				<!-- <div class="noCommodity" v-if="commodity.length==0">
					没有检索到您需要的商品，请更换检索条件
				</div> -->
				<div class="commodity">
					<commodityList ref="refresh" v-bind:commodity="commodity" v-bind:type='"normal"'></commodityList>
				</div>
				<div class="pager">
					<el-pagination background layout="prev, pager, next" :page-size="limit" :current-page="page" :total="totalPage*limit" @current-change="clickPage" @prev-click="prevPage" @next-click="nextPage"></el-pagination>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	// your script
	import Head from '../../components/head.vue'
	import Foot from '../../components/foot.vue'
	import commodityList from '../../components/commodityList.vue'
	export default {
		name: 'type',
		components:{
			Head,Foot,commodityList
		},
		data(){
			return {
				filtrate:[],
				height:"max-height:60px",
				page:1,
				commodity:[],
				limit:25,
				totalPage:1,
				obj:{
					"search_name":"",
					"brand_id":"",
					"cat_id":""
				},
				select1:"select",
				select2:"",
				select3:"",
				select2up:true,
				select3up:true
			}
		},
		methods:{
			getDefault(){
				this.select1 = 'select'
				this.select2 = ''
				this.select3 = ''
				this.select2up=true
				this.select3up=true
				this.query(1);
				this.page=1
				
			},
			getSales(){
				if(this.select2up){
					this.select2up=false
				}else{
					this.select2up=true
				}
				this.select1 = ''
				this.select2 = 'select'
				this.select3 = ''
				this.select3up=true
				this.query(2);
				this.page=1
			},
			getPrice(){
				if(this.select3up){
					this.select3up=false
				}else{
					this.select3up=true
				}
				this.select1 = ''
				this.select2 = ''
				this.select3 = 'select'
				this.select2up=true
				this.query(3);
				this.page=1
			},
			getGoodList(e){
				var page = this.page
				
				var that = this
				this.request(data,function(res){
					console.log(res)
					if(res.status){
						var list = res.data.list
						for (var i = 0; i < list.length; i++) {
							var item = list[i]
							var obj = {
								"avatar":item.image_url,
								"price":item.price,
								"name":item.name,
								"id":item.id
							}
							that.commodity.push(obj)
						}
						that.$refs.refresh.setData()
						that.totalPage = res.data.total_page
					}else{
						
					}
				})
			},
			getSearch(e){
				var index = e.target.dataset.index
				var id = e.target.dataset.id
				if(index=="1"){
					this.obj['brand_id'] = id
				}else{
					this.obj['cat_id'] = id
				}
				for (var i = 0; i < this.filtrate.length; i++) {
					var fid = this.filtrate[i].id
					if(index==fid){
						for (var k = 0; k < this.filtrate[i].tab.length; k++) {
							var tid = this.filtrate[i].tab[k].id
							this.filtrate[i].tab[k].select = ''
							if(tid==id){
								this.filtrate[i].tab[k].select='filtrateSelect'
							}
						}
					}
				}
				var data = {
					page: this.page,
					limit: this.limit,
					where: JSON.stringify(this.obj),
					method: 'goods.getlist'
				}
				this.commodity = []
				var that = this
				this.request(data,function(res){
					if(res.status){
						var list = res.data.list
						for (var i = 0; i < list.length; i++) {
							var item = list[i]
							var obj = {
								"avatar":item.image_url,
								"price":item.price,
								"sale":item.buy_count,
								"name":item.name,
								"id":item.id
							}
							that.commodity.push(obj)
						}
						that.$refs.refresh.setData()
						that.totalPage = res.data.total_page
					}else{
						that.globalTest('goods.getlist.search','error',res.msg,res.data)
					}
				})
			},
			clearFiltrate(){
				this.$router.go(0)
			},
			clickPage(page){
				this.page = page
				this.commodity = []
				this.query()
			},
			prevPage(e){
				this.page = e
			},
			nextPage(e){
				this.page = e
			},
			query(e){
				var data = {
					page: this.page,
					limit: this.limit,
					where: '',
					method: 'goods.getlist',
					order:''
				}
				if(e==1){
					data['order']=''
				}else if(e==2){
					if(this.select2up){
						data['order'] = "buy_count desc"
					}else if(!this.select2up){
						data['order'] = "buy_count asc"
					}
				}else if(e==3){
					if(this.select3up){
						data['order']= "price desc"
					}else if(!this.select3up){
						data['order'] = "price asc"
					}
				}
				if(this.type=='search'){
					data['where'] = JSON.stringify({"search_name":this.search})
				}else if(this.type=='catid'){
					data['where'] = JSON.stringify({"cat_id":this.catid})
				}else if(this.type=='brand'){
					data['where'] = JSON.stringify({"brand_id":this.brand})
				}
				this.commodity = []
				var that = this
				this.request(data,function(res){
					if(res.status){
						var brand = res.data.brand
						var cat = res.data.cat
						var obj = {
							"name":"品牌",
							"id":"1",
							"tab":brand
						}
						var obj2 = {
							"name":"分类",
							"id":"2",
							"tab":cat
						}
						that.filtrate =[]
						that.filtrate.push(obj)
						that.filtrate.push(obj2)
						var list = res.data.list
						for (var i = 0; i < list.length; i++) {
							var item = list[i]
							var obj = {
								"avatar":item.image_url,
								"price":item.price,
								"sale":item.buy_count,
								"name":item.name,
								"id":item.id
							}
							that.commodity.push(obj)
						}
						that.$refs.refresh.setData()
						that.totalPage = res.data.total_page
					}else{
						that.globalTest('goods.getlist.search','error',res.msg,res.data)
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.tid = this.$route.query.tid
			this.type = this.$route.query.type
			if(this.type=='search'){
				this.search = this.$route.query.search
				this.query()
			}else if(this.type=='catid'){
				this.catid = this.$route.query.catid
				this.query()
			}else if(this.type=='brand'){
				this.brand = this.$route.query.brand
				this.query()
			}
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.filtrate{
		width: 100%;
		border: 1px solid #C3C3C3;
		box-sizing: border-box;
		padding: 10px 9px;
		margin-top: 10px;
	}
	.block{
		width: 100%;
		border-bottom: 1px solid #D3D3D3;
		line-height: 30px;
		position: relative;
		overflow: hidden;
	}
	.block:last-child{
		border-bottom: none;
	}
	.clearFiltrate{
		width: 100%;
		line-height: 30px;
	}
	.clearFiltrate .clearIn{
		width: 100px;
		height: 100%;
		cursor: pointer;
	}
	.clearFiltrate .clearIn:hover{
		background: #FFFFFF;
		color: red;
	}
	.blockTitle{
		width: 150px;
		height: 30px;
		position: absolute;
		left: 0px;
		top: 0px;
	}
	.blockBox{
		width: 100%;
		height: 100%;
		padding-left: 150px;
		padding-right: 100px;
		box-sizing: border-box;
		font-size: 0px;
		letter-spacing: -6px;
	}
	.blockItem{
		max-width: 200px;
		height: 30px;
		display: inline-block;
		vertical-align: top;
		padding: 0px 10px;
		box-sizing: border-box;
		font-size: 12px;
		letter-spacing: normal;
		overflow: hidden;
		color: #838383;
		cursor: pointer;
	}
	.blockItem:hover{
		color: #036DEE;
	}
	#filtrateSelect{
		background: #FFFFFF;
		border-left: 1px solid red;
		border-right: 1px solid red;
		color: red;
	}
	.blockMore{
		width: 100px;
		height: 30px;
		position: absolute;
		right: 0px;
		top: 0px;
	}
	.moreBtn{
		width: 80px;
		height: 24px;
		border: 1px solid #C3C3C3;
		text-align: center;
		box-sizing: border-box;
		line-height: 22px;
		margin: 3px auto;
		font-size: 12px;
		color: #333333;
		cursor: pointer;
	}
	.moreBtn:hover{
		color: #036DEE;
		border: 1px solid #036DEE;
	}
	.order{
		width: 100%;
		height: 50px;
		border: 1px solid #D3D3D3;
		margin-top: 30px;
		line-height: 50px;
		text-align: center;
		background: -webkit-linear-gradient(#F3F3F3, #F0F0F0); /* Safari 5.1 - 6.0 */
		background: -o-linear-gradient(#F3F3F3, #F0F0F0); /* Opera 11.1 - 12.0 */
		background: -moz-linear-gradient(#F3F3F3, #F0F0F0); /* Firefox 3.6 - 15 */
		background: linear-gradient(#F3F3F3, #F0F0F0); /* 标准的语法 */
	}
	.noCommodity{
		width: 100%;
		height: 70px;
		line-height: 70px;
		font-size: 20px;
		color: #838383;
	}
	.default,.sales,.price{
		width: 100px;
		height: 100%;
		float: left;
	}
	.pager{
		width: 100%;
		height: 50px;
		margin-top: 30px;
	}
	#select{
		background: #FFFFFF;
		border-right: 1px solid #D3D3D3;
		box-sizing: border-box;
		color: red;
	}
</style>
